import Login from 'containers/Login';
import AccountWithGQL from 'containers/Account/AccountWithGQL';
import cookie from 'cookie';
import PropTypes from 'prop-types';
import { useState, useContext } from 'react';
import globalProps from 'utils/globalProps';
import { StorefrontContext } from 'providers/storefront';
import { setCustomerToken as setCustomerTokenCookie } from 'helpers/cookies';

const Me = ({ customerToken }) => {
  const [localCustomerToken, setLocalCustomerToken] = useState(customerToken);
  const { setIsLoggedIn } = useContext(StorefrontContext);

  const handleLogin = (token) => {
    setIsLoggedIn(true);
    setCustomerTokenCookie(token);
    setLocalCustomerToken(JSON.stringify(token));
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    setLocalCustomerToken(null);
  };
  return (
    <div className="login">
      {localCustomerToken ? (
        <AccountWithGQL
          customerToken={localCustomerToken}
          handleLogout={handleLogout}
        />
      ) : (
        <Login handleLogin={handleLogin} />
      )}
      <style>
        {`
        .login{
          // margin-top:48px;
          background: #000000;
        }
        @media (max-width:991px){
          .login{
            // margin-top:0px;
          }
        }
        `}
      </style>
    </div>
  );
};

export async function getServerSideProps(context) {
  const {
    props: { global },
  } = await globalProps();
  const cookies = context.req.headers.cookie
    ? cookie.parse(context.req.headers.cookie)
    : {};
  return {
    props: {
      global,
      customerToken: cookies.customerToken || null,
    },
  };
}

Me.propTypes = {
  customerToken: PropTypes.string,
};

Me.defaultProps = {
  customerToken: null,
};

export default Me;
